import { render, staticRenderFns } from "./CompanyProviderByUser.vue?vue&type=template&id=8a2a9644&scoped=true"
import script from "./CompanyProviderByUser.vue?vue&type=script&lang=js"
export * from "./CompanyProviderByUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a2a9644",
  null
  
)

export default component.exports